import { AUTHORIZE_USER } from '../mutations.js';

import app from '@/js/app.js';
import apiRequest from '@/js/helpers/apiRequest.js';
import setTokenToLocalStorage from '@/js/helpers/setTokenToLocalStorage.js';

export default {
  state: {
    authorized: false
  },

  mutations: {
    [AUTHORIZE_USER]: (state, payload) => {
      state.authorized = payload;
    }
  },

  actions: {
    /**
     * @param {string} email
     * @param {string} password
     * @returns {string} Authorization token
     */
    logIn: async ({ commit }, { email, password }) => {
      const body = new FormData();
      body.append('email', email);
      body.append('password', password);

      const res = await apiRequest('login', 'POST', body);

      if (res.error) {
        throw { customeError: res.error };
      }

      // Set token to Laravel Echo
      app.$echo.connector.options.auth.headers['Authorization'] = `Bearer ${res.success.token}`;
      setTokenToLocalStorage(res.success.token);
    }
  }
};
